module.exports = __webpack_public_path__ + "static/media/n12.53187552.jpg";